
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Login";
import { Toaster } from "react-hot-toast";
import Dashboard from "./Dashboard";
import AddUser from "./AddUser";
import EditUser from "./EditUser";
import Bookings from "./Bookings";
import BookingsByBookingDate from "./BookingsByBookingDate";
import AddBooking from "./AddBooking";
import EditBooking from "./EditBooking";
import Topagents from "./Topagents";
import CancelledBookings from "./CancelledBookings";
import NotFound from "./NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./Home";
import Agencies from "./Agencies";
import FollowUpStatus from "./FollowUpStatus";
import AgentStatement from "./AgentStatement";
import DriverDetails from "./DriverDetails";
import DriverManagement from "./DriverManagement";
import VehicleManagement from "./VehicleManagement";
import RouteManagement from "./RouteManagement";
import BusTimingsManagement from "./BusTimingsManagement";
import HelpFaqManagement from "./HelpFaqManagement";
import MisDashboard from "./MisDashboard";


function App() {
  return (
    <div className="App">

      <Router>
        <Routes>
          <Route path="/" element={<Login/>} />
          <Route path="/home" element={<Home/>} />
          <Route path="/users" element={
            <ProtectedRoute requiredPermission="users">
              <Dashboard/>
            </ProtectedRoute>
          } />
          <Route path="/user/add" element={
            <ProtectedRoute requiredPermission="user/add">
              <AddUser/>
            </ProtectedRoute>
          } />
          <Route path="/user/edit/:id" element={
            <ProtectedRoute requiredPermission="user/edit">
              <EditUser/>
            </ProtectedRoute>
          } />
          <Route path="/bookings" element={
            <ProtectedRoute requiredPermission="bookings">
              <Bookings/>
            </ProtectedRoute>
          } />
          <Route path="/bookings-by-booking-date" element={
            <ProtectedRoute requiredPermission="bookings-by-booking-date">
              <BookingsByBookingDate/>
            </ProtectedRoute>
          } />
          <Route path="/bookings/add" element={
            <ProtectedRoute requiredPermission="bookings/add">
              <AddBooking/>
            </ProtectedRoute>
          } />
          <Route path="/bookings/topagents" element={
            <ProtectedRoute requiredPermission="bookings/topagents">
              <Topagents/>
            </ProtectedRoute>
          } />
          <Route path="/mis-dashboard" element={
            <ProtectedRoute requiredPermission="mis-dashboard">
              <MisDashboard/>
            </ProtectedRoute>
          } />
          <Route path="/bookings/edit/:id" element={
            <ProtectedRoute requiredPermission="bookings/edit">
              <EditBooking/>
            </ProtectedRoute>
          } />
          <Route path="/bookings/cancelled" element={
            <ProtectedRoute requiredPermission="bookings/cancelled">
              <CancelledBookings/>
            </ProtectedRoute>
          } />
          <Route path="/agencies" element={
            <ProtectedRoute requiredPermission="agencies">
              <Agencies/>
            </ProtectedRoute>
          } />
          <Route path="/followup-status" element={
            <ProtectedRoute requiredPermission="followup-status">
              <FollowUpStatus/>
            </ProtectedRoute>
          } />
          <Route path="/agent-statement" element={
            <ProtectedRoute requiredPermission="agentstatement">
              <AgentStatement/>
            </ProtectedRoute>
          } />
          <Route path="/driver-details" element={
            <ProtectedRoute requiredPermission="driverdetails">
              <DriverDetails/>
            </ProtectedRoute>
          } />
          <Route path="/driver-management" element={
            <ProtectedRoute requiredPermission="driver-management">
              <DriverManagement/>
            </ProtectedRoute>
          } />
          <Route path="/vehicle-management" element={
            <ProtectedRoute requiredPermission="vehicle-management">
              <VehicleManagement/>
            </ProtectedRoute>
          } />
          <Route path="/route-management" element={
            <ProtectedRoute requiredPermission="route-management">
              <RouteManagement/>
            </ProtectedRoute>
          } />
          <Route path="/bus-timings-management" element={
            <ProtectedRoute requiredPermission="bus-timings-management">
              <BusTimingsManagement/>
            </ProtectedRoute>
          } />
          <Route path="/help-faq-management" element={
            <ProtectedRoute requiredPermission="help-faq-management">
              <HelpFaqManagement/>
            </ProtectedRoute>
          } />
          <Route path="*" element={<NotFound/>} />
        </Routes>
        <Toaster/>
      </Router>
      
      
    </div>
  );
}

export default App;
